/**
 * INCIPIT · BANNIÈRE PLEINE LARGEUR
 *
 * Déclenche l'animation fade-in en cascade quand la section
 * entre dans le viewport. Utilise IntersectionObserver pour
 * la performance (pas de listener scroll global).
 *
 * Code original Incipit Studio.
 */

(function () {
  'use strict';

  /**
   * Initialise les sections Bannière pleine largeur
   * Idempotent : peut être appelé plusieurs fois (theme editor).
   */
  function initFullWidthBanners() {
    const banners = document.querySelectorAll('[data-incipit-fwb]:not([data-incipit-fwb-initialized])');

    if (banners.length === 0) return;

    // Si IntersectionObserver n'est pas supporté (très rares vieux navigateurs),
    // on révèle tout immédiatement (pas d'animation, mais le contenu reste accessible).
    if (typeof IntersectionObserver === 'undefined') {
      banners.forEach((banner) => {
        banner.setAttribute('data-incipit-fwb-initialized', 'true');
        banner.classList.add('is-revealed');
      });
      return;
    }

    const observer = new IntersectionObserver(
      (entries, obs) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-revealed');
            obs.unobserve(entry.target);
          }
        });
      },
      {
        threshold: 0.15,
        rootMargin: '0px 0px -8% 0px',
      }
    );

    banners.forEach((banner) => {
      banner.setAttribute('data-incipit-fwb-initialized', 'true');

      // Si l'animation est désactivée côté schema, ne rien faire
      // (le CSS gère déjà l'absence de fade-in via .incipit-fwb--animated).
      if (!banner.classList.contains('incipit-fwb--animated')) {
        return;
      }

      // Si la section est déjà dans la viewport au load (above-the-fold),
      // déclencher immédiatement sans attendre le scroll.
      const rect = banner.getBoundingClientRect();
      const isAlreadyVisible =
        rect.top < window.innerHeight * 0.9 && rect.bottom > 0;

      if (isAlreadyVisible) {
        // Léger délai pour laisser le rendu se stabiliser avant l'animation
        requestAnimationFrame(() => {
          banner.classList.add('is-revealed');
        });
      } else {
        observer.observe(banner);
      }
    });
  }

  // Initialisation au DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFullWidthBanners);
  } else {
    initFullWidthBanners();
  }

  // Re-init lors du rechargement d'une section dans l'éditeur Shopify
  document.addEventListener('shopify:section:load', initFullWidthBanners);

  // Pause / clean au reload aussi pour les sections supprimées
  document.addEventListener('shopify:section:unload', (event) => {
    const banner = event.target.querySelector('[data-incipit-fwb]');
    if (banner) banner.classList.remove('is-revealed');
  });
})();